import React from 'react'
import styles from './Settings.module.css'
import cx from 'classnames'
import Heading from '../../components/Heading'
import ColorsManagement from '../../compositions/ColorsManagement'

const Settings: React.FC = () => {
    return (
        <div>
            <ColorsManagement />
        </div>
    )
}
 
export default Settings
